export var useFunctions = function (props) {
    var setStepIndex = props.setStepIndex, patterns = props.patterns, setPatterns = props.setPatterns;
    var plusStep = function (step) {
        setStepIndex(step + 1);
    };
    var updateScore = function (targetCategory, value) {
        setPatterns(function (prevState) {
            return prevState.map(function (obj) {
                return obj.category === targetCategory.category
                    ? {
                        category: obj.category,
                        score: obj.score + value,
                        title: obj.title,
                        description: obj.description,
                        imageUrl: obj.imageUrl,
                        slideimageUrl1: obj.slideimageUrl1,
                        slideimageUrl2: obj.slideimageUrl2,
                        slideimageUrl3: obj.slideimageUrl3,
                        pointimageUrl1: obj.pointimageUrl1,
                        pointimageUrl2: obj.pointimageUrl2,
                        pointimageUrl3: obj.pointimageUrl3,
                        buttonUrl: obj.buttonUrl,
                    }
                    : obj;
            });
        });
    };
    return { plusStep: plusStep, updateScore: updateScore };
};
